// @flow

import * as React from 'react';
import classNames from '@ta/common.classnames';
import type { NavLinkType } from '../types';
import SideBarNavItem from './SideBarNavItem';
import styles from './VisibleLinks.less';

type Props = {|
  /** Array of visible links (hotels, vr, flights, restaurants, things to do) */
  links: NavLinkType[],
  /** Callback for expanding item */
  expandLinks?: (subLinks: NavLinkType[], e: SyntheticEvent<*>) => void,
|};

/** Convert the visible links into side bar nav items. Visible links are the nav links are not part of the collapsed menu (Hotels, VR, Flights, Restaurants, ...). Does not include "More", "Help Center", "Settings", "Sign out" */
const VisibleLinks = ({ links, expandLinks }: Props) => {
  const container = classNames('ui_container', styles.visibleLinksContainer);
  return (
    <ul className={container}>
      {links.map(link => (
        <SideBarNavItem
          key={link.id}
          link={link}
          showIcon
          hasSubItem={link.subList && link.subList.length > 0}
          expandLinks={expandLinks}
        />
      ))}
    </ul>
  );
};

export default VisibleLinks;
